import { Splide } from '../main.js';

const splideCarouselEl = document.querySelectorAll('.js-splide-carousel');

if (splideCarouselEl.length > 0) {
    Array.from(splideCarouselEl).forEach((carousel) => {
        const carouselLength = carousel.querySelectorAll('.splide__slide').length;

        const splideCarousel = new Splide(carousel, {
            rewind: true,
            perPage: 4,
            perMove: 1,
            type: carouselLength > 3 ? 'loop' : 'slide',
            gap: 32,
            speed: 700,
            drag: carouselLength > 3 ? true : false,
            pagination: false,
            arrows: false,
            trimSpace: 'move',

            breakpoints: {
                1440: {
                    perPage: 3,
                    padding: '0rem',
                    gap: 24,
                    omitEnd: false,
                    focus: false,
                    drag: carouselLength > 1 ? true : false,
                    type: carouselLength > 1 ? 'loop' : 'slide',
                },

                1024: {
                    perPage: 2,
                    padding: '4rem',
                    gap: 24,
                    omitEnd: true,
                    focus: 'center',
                    drag: carouselLength > 1 ? true : false,
                    type: carouselLength > 1 ? 'loop' : 'slide',
                },

                640: {
                    perPage: 1,
                    padding: '6rem',
                    gap: 32,
                    omitEnd: true,
                    focus: 'center',
                    drag: carouselLength > 1 ? true : false,
                    type: carouselLength > 1 ? 'loop' : 'slide',
                },
            },
        });

        const splideList = splideCarousel.root.querySelector('.splide__list');

        // Events
        splideCarousel.on('resized', (e) => {
            const splideLength = splideCarousel.length;
            const splidePerPage = splideCarousel.options.perPage;

            if (splideLength < splidePerPage) {
                splideCarousel.destroy();
                splideList.classList.add('splide__list--grid');
            } else {
                splideList.classList.remove('splide__list--grid');
            }
        });

        // INIT
        splideCarousel.mount();
    });
}
